import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';

@Component({
  selector: 'app-request-comment',
  templateUrl: './request-comment.component.html',
  styleUrls: ['./request-comment.component.css']
})
export class RequestCommentComponent implements OnInit {

  _isFocus: boolean = false;
  _isCancelRequest: boolean = false;
  isValid: boolean = true;


  @Output()
  onSaveComment = new EventEmitter<string>();

  @Output()
  hasComment = new EventEmitter<string>();

  comment: string = '';

  @ViewChild('commentInput')
  commentInput: any;

  @Input()
  disabled: boolean = false;

  @Input()
  onload: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  @Input()
  set isCancelRequest(isCancelRequest: boolean){
    this._isCancelRequest = isCancelRequest
    if(this._isCancelRequest){
      this.commentInput.nativeElement.focus();
      this._isFocus = true;
    } else {
      this.isValid = true;
      this._isFocus = false;
    }
  }

  onSave(){
    this.onSaveComment.emit(this.comment);
  }

  clearComment(){
    this.comment = '';
  }

  onBlurComment(){
    if(this.comment != '' && this._isCancelRequest){
      this.isValid = true
      this._isFocus = false;
    } else if(this._isCancelRequest){
      this.isValid = false;
    } else {
      this.isValid = true;
    }
  }

  onChangeComment(){
    this.hasComment.emit(this.comment)
  }

}



// WEBPACK FOOTER //
// /app/src/app/modules/request/request-comment/request-comment.component.ts